// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1w_Mg","alert":"SettungsInbox_alert__1mQIL"};